interface RetargetRefreshIconProps {
  className?: string;
}

export default function RetargetRefreshIcon({
  className,
}: RetargetRefreshIconProps) {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.75 8.35C7.24 4.41 12.59 3.41 16.66 4.59C17.25 4.76 17.82 5 18.34 5.31"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.54 3.79L18.98 5.68L16.08 6.72"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="7.1"
        cy="13.4"
        r="4.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="7.1" cy="13.4" r="1.65" fill="currentColor" />
      <circle
        cx="16.9"
        cy="13.4"
        r="4.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="16.9" cy="13.4" r="1.65" fill="currentColor" />
    </svg>
  );
}
